import { render } from "./comp-progress-round.vue?vue&type=template&id=000083a2"
import script from "./comp-progress-round.vue?vue&type=script&lang=js"
export * from "./comp-progress-round.vue?vue&type=script&lang=js"

import "./comp-progress-round.vue?vue&type=style&index=0&id=000083a2&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__